const Header = (props) => {
    return (
        <header >
            <nav className="navbar bg-body fixed-top" style={{ paddingTop: 0, paddingBottom: 0 }} >

                <div className="container-fluid pl-3  d-flex align-items-center" style={{ backgroundColor: "#000000"}} >
                    <div>
                        <img src="mlm_logo.png" style={{ height: 25 + '%', width: 25 + '%'}}></img>
                        <span className="navbar-brand text-white fs-6 ms-2" ></span>
                    </div>
                    
                    <span className="navbar-brand text-white fs-5"><strong>Invoice Extraction</strong></span>
                </div>
            </nav>
        </header>
    );
}

export default Header;